const paymentRequest = require('./payment-request.json');
const paymentSubmission = require('./payment-submission.json');

/**
 * Sale related validation schemas
 * @module schemas/sales
 * @property {module:schemas/payment/paymentrequest} payment-request - schema compliant file for payment-request
 * @property {module:schemas/payment/paymentsubmission} payment-submission - schema compliant file for payment-submission
 */
module.exports = {
  paymentRequest,
  paymentSubmission,
};
